export default __webpack_public_path__ + "static/media/fio-twitter-summary-card.21be3752.png";